import { useEventListener } from "@redotech/react-util/event";
import { useState } from "react";

export function useClickRefresh({ selector }: { selector: string }) {
  const [clickEvent, setClickEvent] = useState<symbol>(Symbol());

  useEventListener(
    document,
    "click",
    (e: Event) => {
      if (
        selector &&
        e.target instanceof Element &&
        // Check if the click was one of the elements that could trigger a cart change or open.
        e.target.matches(selector)
      ) {
        for (let i = 1; i <= 5; i *= 2) {
          setTimeout(() => setClickEvent(Symbol()), i * 500);
        }
      }
    },
    true,
  );

  return clickEvent;
}
